export const allowedAppIds = ['23', '26', '28', '29', '31', '32', '33', '36', '37', '47']
export const isStaging = process.env.REACT_APP_SERVER_ENV === 'staging'
